import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import oktaApiClient from './oktaApiClient';
import { usePortalAccess } from '../../context/PortalAccessContext';

const CODE_VERIFIER_KEY = 'ubiquity.okta_code_verifier';

export default function OktaLoginCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setPortalAccess } = usePortalAccess();
  const [status, setStatus] = useState('Signing you in...');
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    const errorParam = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (errorParam) {
      setError(errorDescription || errorParam);
      setStatus('');
      return;
    }
    if (!code) {
      setError('Missing authorization code.');
      setStatus('');
      return;
    }

    let verifier = '';
    try {
      verifier = sessionStorage.getItem(CODE_VERIFIER_KEY) || '';
      sessionStorage.removeItem(CODE_VERIFIER_KEY);
    } catch (_err) {
      setError('Could not access session storage.');
      setStatus('');
      return;
    }

    if (!verifier) {
      setError('Session expired. Please login again.');
      setStatus('');
      return;
    }

    oktaApiClient
      .post('/auth/okta/token', { code, code_verifier: verifier })
      .then(async (res) => {
        if (res.data?.success) {
          const email = res.data?.user?.email;
          if (email) {
            try {
              const accessContext = await oktaApiClient.post('/portal/access-context', { email });
              setPortalAccess({
                email: accessContext.data?.email || email,
                scope: accessContext.data?.scope || 'GLOBAL',
              });
            } catch (_err) {
              // Keep login successful even if scope lookup fails.
              setPortalAccess({ email, scope: 'GLOBAL' });
            }
          }
          navigate('/', { replace: true });
          return;
        }
        setError(res.data?.error || 'Login failed.');
        setStatus('');
      })
      .catch((err) => {
        const message = err?.response?.data?.error || err?.message || 'Login failed.';
        setError(message);
        setStatus('');
      });
  }, [searchParams, navigate, setPortalAccess]);

  if (error) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p style={{ color: '#c00', marginBottom: '1rem' }}>{error}</p>
        <a href="/login">Return to login</a>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>{status}</p>
    </div>
  );
}
